<!-- Skeleton Loader -->
@if (loading) {
<div class="dash-main-content">
  <div class="dash-top">
    <h2 class="dash-title">Détails de l'application</h2>
  </div>
  <!-- Skeleton header -->
  <div class="details-skeleton">
    <div class="skeleton-header">
      <div class="skeleton-avatar"></div>
      <div class="skeleton-info">
        <div class="skeleton-line w-48"></div>
        <div class="skeleton-line w-32"></div>
      </div>
    </div>
    @for (_ of [1,2,3]; track _) {
    <div class="skeleton-card">
      <div class="skeleton-line w-40"></div>
      <div class="skeleton-line w-60"></div>
      <div class="skeleton-line w-80"></div>
    </div>
    }
  </div>
</div>
}

<!-- Contenu réel -->
@if (!loading && client) {
<div class="dash-main-content">
  <!-- Titre & actions -->
  <div class="dash-top">
    <div class="dash-action">
      <div class="dash-action-left">
        <h2 class="dash-title" style="margin:0;">
          {{ client.name || client.clientId }}
          <span class="badge" [ngClass]="client.enabled ? 'success' : 'danger'">
            {{ client.enabled ? 'Actif' : 'Inactif' }}
          </span>
        </h2>
        <span class="text-gray" style="font-size:0.9rem;">ID: {{ client.clientId }}</span>
      </div>
      <div class="dash-action-right">
        <a [routerLink]="['/dashboard/clients', client.id, 'edit']" class="button button-icon primary medium">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
              stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M13 4L20 11" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M14 22L22 22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>Modifier</span>
        </a>
        <button class="button danger icon medium" (click)="deleteClient()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 7H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M9 7V5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7" stroke="currentColor"
              stroke-width="1.5" stroke-linecap="round" />
            <path d="M19 7L18.5 19C18.5 20.1046 17.6046 21 16.5 21H7.5C6.39543 21 5.5 20.1046 5.5 19L5 7"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M10 11V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M14 11V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <span>Supprimer</span>
        </button>
        @if (!client.publicClient) {
        <button class="button neutral icon medium" (click)="regenerateSecret()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8V12L14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="currentColor" stroke-width="1.5" />
          </svg>
          <span>Régénérer secret</span>
        </button>
        }
        <button class="button neutral icon medium" (click)="goBack()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 12H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M10 18L4 12L10 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <span>Retour</span>
        </button>
      </div>
    </div>
  </div>
  <!-- Contenu -->
  <div class="tabs">
    <div class="tab-panels">
      <div class="tab-panel active">
        <!-- Résumé -->
        <div class="card" style="margin-bottom:24px;">
          <div class="card-element card-element-4">
            <div class="key-value">
              <span>Type</span>
              <p><span class="badge" [ngClass]="getClientTypeColor()">{{ getClientType() }}</span></p>
            </div>
            <div class="key-value">
              <span>Protocole</span>
              <p>{{ client.protocol || 'openid-connect' }}</p>
            </div>
            <div class="key-value">
              <span>Flows activés</span>
              <p>{{ getEnabledFlowsCount() }}/4</p>
            </div>
            <div class="key-value">
              <span>URLs configurées</span>
              <p>{{ (client.redirectUris?.length || 0) + (client.webOrigins?.length || 0) }}</p>
            </div>
          </div>
        </div>
        <!-- Informations de base -->
        <div class="accordion-item" [class.active]="basicInfoExpanded">
          <button class="accordion" (click)="basicInfoExpanded = !basicInfoExpanded">
            <div class="accordion-elements">
              <div class="accordion-left df-center-8">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="#45B56F" stroke-width="1.5" />
                  <path d="M12 8V12" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M12 16H12.01" stroke="#45B56F" stroke-width="2" stroke-linecap="round" />
                </svg>
                <span>Informations de base</span>
              </div>
              <div class="accordion-right">
                <span>{{ basicInfoExpanded ? '▼' : '▶' }}</span>
              </div>
            </div>
          </button>
          <div class="panel" [style.display]="basicInfoExpanded ? 'block' : 'none'">
            <div class="card">
              <!-- Ligne 1 : Nom + ID Client -->
              <div class="key-value-grid two-cols">
                @if (client.name) {
                <div class="key-value">
                  <span>Nom</span>
                  <p>{{ client.name }}</p>
                </div>
                }
                <div class="key-value">
                  <span>ID Client</span>
                  <p><code>{{ client.clientId }}</code></p>
                </div>
              </div>
              <!-- Ligne 2 : Root URL + Base URL (si présents) -->
              @if (client.rootUrl || client.baseUrl) {
              <div class="key-value-grid two-cols">
                @if (client.rootUrl) {
                <div class="key-value">
                  <span>Root URL</span>
                  <p><a href="{{ client.rootUrl }}" target="_blank">{{ client.rootUrl }}</a></p>
                </div>
                }
                @if (client.baseUrl) {
                <div class="key-value">
                  <span>Base URL</span>
                  <p><a href="{{ client.baseUrl }}" target="_blank">{{ client.baseUrl }}</a></p>
                </div>
                }
              </div>
              }
              <!-- Description -->
              @if (client.description) {
              <div class="key-value full-width">
                <span>Description</span>
                <p>{{ client.description }}</p>
              </div>
              }
            </div>
          </div>
        </div>
        <!-- Rôles du client -->
        <div class="accordion-item" [class.active]="listeRolesExpanded">
          <button class="accordion" (click)="listeRolesExpanded = !listeRolesExpanded">
            <div class="accordion-elements">
              <div class="accordion-left df-center-8">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
                    stroke="#45B56F" stroke-width="1.5" />
                  <path
                    d="M2.90625 20.2501C3.82775 18.6537 5.15328 17.3278 6.74957 16.4058C8.34585 15.4838 10.1567 15 12.0003 15C13.8438 15 15.6547 15.4838 17.251 16.4058C18.8473 17.3278 20.1728 18.6537 21.0943 20.2501"
                    stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>Rôles du client @if (totalRoles > 0) {
                  <span class="badge info">{{ totalRoles }}</span>
                  }</span>
              </div>
              <div class="accordion-right">
                <span>{{ listeRolesExpanded ? '▼' : '▶' }}</span>
              </div>
            </div>
          </button>
          <div class="panel">
            <div class="card">
              <!-- Liste -->
              @if (!rolesLoading && !rolesError && clientRoles.length > 0) {
              <div>
                @for (role of clientRoles; track role) {
                <div class="role-item">
                  <div class="role-header">
                    <span class="badge" [ngClass]="role.composite ? 'purple' : 'success'">
                      {{ role.composite ? 'Composite' : 'Simple' }}
                    </span>
                    <strong>{{ role.title || role.name }}</strong>
                    @if (role.title) {
                    <span class="role-name text-gray">({{ role.name }})</span>
                    }
                  </div>
                  @if (role.description) {
                  <div class="role-description text-gray">
                    {{ role.description }}
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
          </div>
        </div>
        <!-- Configuration de sécurité -->
        <!-- <div class="accordion-item" [class.active]="securityExpanded">
                        <button class="accordion" (click)="securityExpanded = !securityExpanded">
                          <div class="accordion-elements">
                            <div class="accordion-left df-center-8">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="#45B56F" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M12 8V12" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                  <path d="M12 16H12.01" stroke="#45B56F" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                <span>Configuration de sécurité</span>
                              </div>
                              <div class="accordion-right">
                                <span>{{ securityExpanded ? '▼' : '▶' }}</span>
                              </div>
                            </div>
                          </button>
                          <div class="panel" [style.display]="securityExpanded ? 'block' : 'none'">
                            <div class="card">
                              <h4>Type de client</h4>
                              <div style="display:flex;flex-wrap:wrap;gap:12px;margin-bottom:24px;">
                                <span class="badge" [ngClass]="{'success': client.publicClient}">Public</span>
                                <span class="badge" [ngClass]="{'success': client.bearerOnly}">Bearer Only</span>
                                <span class="badge"
                                [ngClass]="{'success': !client.publicClient && !client.bearerOnly}">Confidentiel</span>
                              </div>
                              <h4>Flows OAuth / OIDC</h4>
                              <div class="card-element card-element-2">
                                <div *ngFor="let flow of getEnabledFlows()" class="key-value">
                                  <span>{{ flow.name }}</span>
                                  <p><span class="badge" [ngClass]="flow.enabled ? 'success' : 'danger'">{{ flow.enabled ? 'Activé' :
                                  'Désactivé' }}</span></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->
        <!-- URLs et Origines -->
        <div class="accordion-item" [class.active]="urlsExpanded">
          <button class="accordion" (click)="urlsExpanded = !urlsExpanded">
            <div class="accordion-elements">
              <div class="accordion-left df-center-8">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3919C12.2357 14.7347 12.9315 14.9372 13.6454 14.9856C14.3593 15.034 15.0739 14.9271 15.7406 14.6709C16.4074 14.4147 17.0091 14.0145 17.5 13.5L20 11C20.9198 10.1129 21.4867 8.92864 21.6006 7.65348C21.7145 6.37831 21.368 5.11639 20.6265 4.07929C19.885 3.04219 18.8015 2.30512 17.5585 1.98733C16.3154 1.66954 14.9997 1.79529 13.8402 2.34L12 3.5"
                    stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                  <path
                    d="M14 11C13.5705 10.4259 13.0226 9.95086 12.3934 9.60812C11.7643 9.26537 11.0685 9.06281 10.3546 9.01445C9.64067 8.96609 8.92608 9.07286 8.25936 9.32908C7.59264 9.5853 6.99091 9.98551 6.5 10.5L4 13C3.08018 13.8871 2.51328 15.0714 2.39939 16.3465C2.28551 17.6217 2.63204 18.8836 3.37352 19.9207C4.115 20.9578 5.19851 21.6949 6.44154 22.0127C7.68457 22.3305 9.00028 22.2047 10.1598 21.66L12 20.5"
                    stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>URLs et Origines</span>
              </div>
              <div class="accordion-right">
                <span>{{ urlsExpanded ? '▼' : '▶' }}</span>
              </div>
            </div>
          </button>
          <div class="panel">
            <div class="card">
              @if (client.redirectUris?.length) {
              <div>
                <h4>URLs de redirection</h4>
                <div class="url-grid">
                  @for (uri of client.redirectUris; track uri) {
                  <div class="url-item">
                    <span>{{ uri }}</span>
                    <button class="button-no-style" (click)="copyToClipboard(uri, 'URL')">
                      <!-- icône copie -->
                    </button>
                  </div>
                  }
                </div>
              </div>
              }
              @if (client.webOrigins?.length) {
              <div style="margin-top:24px;">
                <h4>Origines web (CORS)</h4>
                <div class="url-grid">
                  @for (origin of client.webOrigins; track origin) {
                  <div class="url-item">
                    <span>{{ origin }}</span>
                    <button class="button-no-style" (click)="copyToClipboard(origin, 'Origine')">...</button>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        <!-- Avancé -->
        <!-- <div class="accordion-item" [class.active]="advancedExpanded">
                            <button class="accordion" (click)="advancedExpanded = !advancedExpanded">
                              <div class="accordion-elements">
                                <div class="accordion-left df-center-8">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 8V12L14 14" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                                    <circle cx="12" cy="12" r="9" stroke="#45B56F" stroke-width="1.5" />
                                  </svg>
                                  <span>Configuration avancée</span>
                                </div>
                                <div class="accordion-right">
                                  <span>{{ advancedExpanded ? '▼' : '▶' }}</span>
                                </div>
                              </div>
                            </button>
                            <div class="panel" [style.display]="advancedExpanded ? 'block' : 'none'">
                              <div class="card">
                                <div class="key-value">
                                  <span>ID technique</span>
                                  <p><code style="background:#F0F1F1;padding:2px 8px;border-radius:4px;">{{ client.id }}</code></p>
                                </div>
                                <div class="key-value">
                                  <span>Protocole</span>
                                  <p>{{ client.protocol || 'openid-connect' }}</p>
                                </div>
                                <div class="key-value" *ngIf="client.attributes && Object.keys(client.attributes).length">
                                  <span>Attributs personnalisés</span>
                                  <div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:8px;">
                                    <span class="badge" *ngFor="let attr of Object.entries(client.attributes)">{{ attr[0] }}: {{ attr[1]
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
        <!-- Utilisateurs -->
        <div class="accordion-item" [class.active]="usersExpanded">
          <button class="accordion" (click)="usersExpanded = !usersExpanded">
            <div class="accordion-elements">
              <div class="accordion-left df-center-8">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
                    stroke="#45B56F" stroke-width="1.5" />
                  <path
                    d="M2.90625 20.2501C3.82775 18.6537 5.15328 17.3278 6.74957 16.4058C8.34585 15.4838 10.1567 15 12.0003 15C13.8438 15 15.6547 15.4838 17.251 16.4058C18.8473 17.3278 20.1728 18.6537 21.0943 20.2501"
                    stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>Utilisateurs @if (totalUsers > 0) {
                  <span class="badge info">{{ totalUsers }}</span>
                  }</span>
              </div>
              <div class="accordion-right">
                <span>{{ usersExpanded ? '▼' : '▶' }}</span>
              </div>
            </div>
          </button>
          <div class="panel" [style.display]="usersExpanded ? 'block' : 'none'">
            <div class="card">
              <!-- Filtre par rôle -->
              <div class="flex gap-16 align-center" style="margin-bottom:16px; flex-wrap: wrap;">
                <input type="text" class="search-input" [(ngModel)]="usersSearchTerm"
                  (ngModelChange)="onUsersSearchChange($event)"
                  placeholder="Rechercher (nom, prénom, email, IES, établissement)..." style="flex: 1 1 320px; min-width: 240px; padding: 8px 12px;
           border: 1px solid #E1E2E2; border-radius: 6px; font-size: 0.95rem;" />

                <label for="roleFilter" style="font-weight:600;">Filtrer par rôle :</label>
                <select id="roleFilter" class="select-wrapper" style="min-width:200px;" [(ngModel)]="selectedRoleFilter"
                  (change)="onRoleFilterChange(selectedRoleFilter)">
                  @for (opt of roleOptions; track opt) {
                  <option [value]="opt.name">
                    {{ opt.title }}
                  </option>
                  }
                </select>
                @if (selectedRoleFilter) {
                <button class="button neutral medium" (click)="onRoleFilterChange('')">
                  Réinitialiser
                </button>
                }
              </div>
              <!-- Tableau des utilisateurs -->
              @if (!usersLoading && users.length > 0) {
              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Nom d'utilisateur</th>
                      <th>Prénom</th>
                      <th>Nom</th>
                      <th>Email</th>
                      <th>IES</th>
                      <th>Établissement(s)</th>
                      <th>Rôles</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (user of users; track user) {
                    <tr>
                      <td>{{ user.username }}</td>
                      <td>{{ user.firstName || '-' }}</td>
                      <td>{{ user.lastName || '-' }}</td>
                      <td>{{ user.email || '-' }}</td>
                      <td>
                        @if (!user.sigleIes) {
                        <span class="text-gray">-</span>
                        } @else if (isIesResolving(user.sigleIes)) {
                        <span class="inline-skeleton" aria-label="Résolution IES…"></span>
                        } @else {
                        {{ getIesSigleFor(user.sigleIes) }}
                        }
                      </td>
                      <td>
                        @if (!user.sigleEtablissements || user.sigleEtablissements.length === 0) {
                        <span class="text-gray">-</span>
                        } @else if (isEtabResolving(user.sigleEtablissements)) {
                        <span class="inline-skeleton" aria-label="Résolution établissement…"></span>
                        } @else {
                        @for (sigle of getEtabSiglesFor(user.sigleEtablissements); track sigle) {
                        <span class="badge" style="margin-right:4px;">{{ sigle }}</span>
                        }
                        }
                      </td>
                      <td>
                        @for (role of user.roles; track role) {
                        <span class="badge" style="margin-right:4px;">
                          {{ role.title || role.name }}
                        </span>
                        }
                        @if (!user.roles || user.roles.length === 0) {
                        <span class="text-gray">Aucun rôle</span>
                        }
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
                <!-- Pagination -->
                @if (totalUsers > usersPageSize) {
                <div class="pagination-container">
                  <mat-paginator #usersPaginator [length]="totalUsers" [pageSize]="usersPageSize"
                    [pageIndex]="usersCurrentPage" [pageSizeOptions]="[5, 10, 20, 50]"
                    (page)="onUsersPageChange($event)" showFirstLastButtons>
                  </mat-paginator>
                </div>
                }
              </div>
              } @else {
              @if (usersLoading) {
              <div class="text-align-center" style="padding:20px;">
                <span>Chargement des utilisateurs...</span>
              </div>
              }
              @if (usersError) {
              <div class="text-align-center text-danger">
                {{ usersError }}
                <button class="button neutral medium" (click)="loadUsers()">Réessayer</button>
              </div>
              }
              @if (!usersLoading && !usersError && users.length === 0) {
              <div class="text-align-center text-gray">
                @if (usersSearchTerm) {
                Aucun utilisateur trouvé pour la recherche «&nbsp;{{ usersSearchTerm }}&nbsp;»
                } @else if (selectedRoleFilter) {
                Aucun utilisateur trouvé pour ce client avec le rôle «&nbsp;{{ selectedRoleFilter }}&nbsp;»
                } @else {
                Aucun utilisateur trouvé pour ce client
                }
              </div>
              }
              }
              <!-- États de chargement / erreur / vide -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}